import HeatMapTable from "@/pages/dashboard/components/HeatMapTable/HeatMapTable";
// 文档 https://ali-react-table.js.org/docs/


// 导出interface
export * from "@/pages/dashboard/components/HeatMapTable/_config/interfaces"
export * from "@/pages/dashboard/components/HeatMapTable/_config/hooks"
export * from "@/pages/dashboard/components/HeatMapTable/_config/constants"
// 导出组件
export default HeatMapTable
